

let currentProduct;
let ignoreMutations = false;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');

    currentProduct = `${productParts[0]}`;

    console.log('Base SKU:', currentProduct.toLowerCase());

    // const selectedSizeInput = document.querySelector('fieldset.product-form__input input[type="radio"]:checked');
    //
    // let sizeValue = "";
    //
    // if (selectedSizeInput) {
    //     sizeValue = selectedSizeInput.getAttribute('value') || "";
    // }

    let finalSKU = currentProduct.toLowerCase();

    // if (sizeValue) finalSKU += `-${sizeValue}`;

    const slugifySKU = (s) =>
        (s || '')
            .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
            .replace(/×/g, 'x')
            .replace(/[“”"’‘']/g, '')
            .toLowerCase()
            .replace(/&/g, ' and ')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .replace(/-+/g, '-');

    finalSKU = slugifySKU(finalSKU);

    console.log('Final SKU:', finalSKU);
    return finalSKU;
};

const addPulseEffectTo3DButton = () => {
    const threedButtons = document.querySelectorAll('.mazing-threed-btn');
    if (threedButtons.length > 0) {
        threedButtons.forEach(btn => btn.classList.add('pulse'));
    } else {
        setTimeout(addPulseEffectTo3DButton, 100);
    }
};

const initializeMazing = async (placementSelector) => {
    await mazing({
        customerName: 'POLAR-RECOVERYCOM',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    width: 100%;
                    position: absolute;
                    bottom: 8px;
                    left: 50%;
                    transform: translateX(-50%);
                    justify-content: end;
                    z-index: 2;
                    display: none;
                    padding-right: 25px;
                }

                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%);
                    background-color: transparent !important;
                    margin: 0 !important;
                    width: 100% !important;
                    height: 100% !important;
                }

                .mazing-threed-btn,
                .mazing-ar-btn {
                    z-index: 1;
                    box-shadow: none;
                    width: 70px !important;
                    height: 70px !important;
                    border-radius: 50% !important;
                    z-index: 10;
                    background: white;
                    border-radius: 12px !important;
                    border: solid 2px black;
                }

                .mazing-threed-btn-text,
                .mazing-ar-btn-text {
                    display: none !important;
                }

                @media (max-width: 1024px) {
                    .mazing-button-container {
                        margin-bottom: 40px !important;
                        margin-right: 40px !important;
                    }
                }

                @keyframes pulse {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.1); opacity: 0.7; }
                    100% { transform: scale(1); opacity: 1; }
                }

                .mazing-threed-btn.pulse {
                    animation: pulse 1.5s infinite;
                }
            `,
            placementSelector,
            threedBtn: {
                enabled: true,
                icon: true,
                customText: '',
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        en: "View in Room",
                        de: "Im Raum anzeigen",
                        fr: "Voir dans votre espace",
                        es: "Ver en tu espacio"
                    };
                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized for:', placementSelector);
};

const cleanupMazing = () => {
    document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
    document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());
};

const runMazingForCurrentMode = async () => {
    try {
        ignoreMutations = true;
        cleanupMazing();
        const selector = 'ul[data-testid="media-gallery-grid"] > li:first-child';

        await initializeMazing(selector);
        await showMazingButtonsAfterDelay(500);
        addPulseEffectTo3DButton();
    } finally {
        requestAnimationFrame(() => { ignoreMutations = false; });
    }
};

const showMazingButtonsAfterDelay = async (ms = 500) => {
    const deadline = Date.now() + 8000;
    while (Date.now() < deadline) {
        const nodes = document.querySelectorAll('.mazing-button-container');
        if (nodes.length) {
            setTimeout(() => nodes.forEach(n => n.style.display = 'flex'), ms);
            return;
        }
        await new Promise(r => setTimeout(r, 50));
    }
};

const startGalleryObserver = () => {
    let t;
    const scheduleReinit = () => {
        if (ignoreMutations) return;
        clearTimeout(t);
        t = setTimeout(() => {
            requestAnimationFrame(() => requestAnimationFrame(runMazingForCurrentMode));
        }, 150);
    };

    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
            const targetEl = m.target.nodeType === 1 ? m.target : null;
            const touchesMediaGallery =
                (targetEl && (targetEl.matches('media-gallery') || targetEl.closest?.('media-gallery'))) ||
                [...m.addedNodes].some(n =>
                    n.nodeType === 1 && (n.matches?.('media-gallery') || n.querySelector?.('media-gallery'))
                );
            if (touchesMediaGallery) { scheduleReinit(); break; }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        await runMazingForCurrentMode();
        startGalleryObserver();

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();

